import type { SeasonalEventId } from '~/utils/seasonalWelcome'

export interface SeasonalEventConfig {
  name: SeasonalEventId
  className: string
  emoji: string
  start: Date
  end: Date
}

/**
 * Fenêtre Noël : 15 déc → 5 janv. En janvier (jusqu’au 5), l’année de départ du 15 déc est l’année précédente.
 */
function getChristmasRange(referenceDate: Date): { start: Date; end: Date } {
  const year = referenceDate.getFullYear()
  const month = referenceDate.getMonth()
  const dayOfMonth = referenceDate.getDate()
  if (month === 0 && dayOfMonth <= 5) {
    return {
      start: new Date(year - 1, 11, 15),
      end: new Date(year, 0, 5),
    }
  }
  return {
    start: new Date(year, 11, 15),
    end: new Date(year + 1, 0, 5),
  }
}

function buildSeasonalOverlays(today: Date): SeasonalEventConfig[] {
  const year = today.getFullYear()
  const christmas = getChristmasRange(today)
  return [
    {
      name: 'halloween',
      className: 'halloween-theme',
      emoji: '🎃',
      start: new Date(year, 9, 25),
      end: new Date(year, 10, 2),
    },
    {
      name: 'christmas',
      className: 'christmas-theme',
      emoji: '☃️',
      start: christmas.start,
      end: christmas.end,
    },
    {
      name: 'easter',
      className: 'easter-theme',
      emoji: '🐇',
      start: new Date(year, 3, 1),
      end: new Date(year, 3, 10),
    },
  ]
}

export function findActiveSeasonalEvent(today: Date): SeasonalEventConfig | null {
  const overlays = buildSeasonalOverlays(today)
  for (const event of overlays) {
    if (today >= event.start && today <= event.end) {
      return event
    }
  }
  return null
}
